import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import {GeneralButton} from "../../common/ui/GeneralButton";
import {monthsList} from "../dashboard/constants";

type Format = "xlsx" | "csv" | "pdf";

type Props = {
    open: boolean;
    onClose: () => void;

    year: number;
    month: number;
    format: Format

    setYear: (v: number) => void;
    setMonth: (v: number) => void;
    setFormat: (v: Format) => void;

    onExport: () => void;
    loading: boolean;
};

export const ExportDialog = ({
                                             open,
                                             onClose,
                                             year,
                                             month,
                                             format,
                                             setYear,
                                             setMonth,
                                             setFormat,
                                             onExport,
                                             loading,
                                         }: Props) => {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Export</DialogTitle>

            <DialogContent>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2, mt: 1}}>
                    <TextField
                        label={t("serviceModulesPage.timetrackingPage.export.year")}
                        type="number"
                        value={year}
                        onChange={(e) => setYear(Number(e.target.value))}
                        fullWidth
                    />

                    <FormControl fullWidth>
                        <InputLabel>
                            {t("serviceModulesPage.timetrackingPage.export.month")}
                        </InputLabel>
                        <Select
                            value={month}
                            label={t("serviceModulesPage.timetrackingPage.export.month")}
                            onChange={(e) => setMonth(Number(e.target.value))}
                        >
                            {monthsList.map((m, index) => (
                                <MenuItem key={m} value={index + 1}>
                                    {t(`monthes.${m}`)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel id="export-format-label">
                            {t("serviceModulesPage.timetrackingPage.export.format")}
                        </InputLabel>

                        <Select
                            labelId="export-format-label"
                            id="export-format"
                            value={format}
                            label={t("serviceModulesPage.timetrackingPage.export.format")}
                            onChange={(e) =>
                                setFormat(e.target.value as "xlsx" | "csv" | "pdf")
                            }
                        >
                            <MenuItem value="xlsx">XLSX</MenuItem>
                            <MenuItem value="csv">CSV</MenuItem>
                            <MenuItem value="pdf">PDF</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>

            <DialogActions>
                <GeneralButton appVariant="secondary" onClick={onClose}>
                    {t("buttons.cancel")}
                </GeneralButton>
                <GeneralButton
                    appVariant="primary"
                    onClick={onExport}
                    disabled={loading}
                >
                    {t("buttons.download")}
                </GeneralButton>
            </DialogActions>
        </Dialog>
    );
};